<template>
  <div class="comp-toast">
    <div v-for="toast in toasts" class="toast" :key="toast.uuid" :class="[toast.className]">
      <span v-html="toast.msg" />
      <div class="close" @click="removeToast(toast)">
        <span /><span />
      </div>
    </div>
  </div>
</template>

<script>
  import VueUtil from '@/utils/VueUtil';

  //----------------------------------
  // Private Properties
  //----------------------------------
  let toastVm = null;

  const Toast = {
    name: 'Toast',
    components: {
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {},
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      // const $icon = this.$icon;
      return {
        toasts: [],
        /*
        icon: {
          info: $icon.info,
          success: $icon.success,
          warning: $icon.warning,
          error: $icon.error,
        },
        */
      };
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    filters: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      push(msg, delay, className) {
        const data = {
          uuid: Date.now(),
          msg,
          className,
        };

        if (delay !== Infinity) {
          data.iid = setTimeout(() => {
            this.removeToast(data);
          }, delay);
        }
        // data.icon = this.icon[data.className];
        this.toasts.push(data);
        return data.uuid;
      },
      removeToast(data) {
        clearTimeout(data.iid);
        const index = this.toasts.findIndex(item => item.uuid === data.uuid);
        this.toasts.splice(index, 1);
        if (this.toasts.length === 0) {
          this.destroy();
        }
      },
      removeToastById(id) {
        const toast = this.toasts.find(item => item.uuid === id);
        if (toast) {
          this.removeToast(toast);
        }
      },
      destroy() {
        this.$destroy();
        this.$el.parentNode.removeChild(this.$el);
        toastVm = null;
      },
    },
  };

  //----------------------------------
  // Private Properties / Methods
  //----------------------------------
  toastVm = null;
  const createToast = (msg, delay, className) => {
    if (!toastVm) {
      toastVm = VueUtil.createComponent(Toast, document.body);
    }
    return toastVm.push(msg, delay, className);
  };
  //----------------------------------
  // Static Methods
  //----------------------------------

  Toast.info = (msg, delay = 5000) => createToast(msg, delay, 'info');
  Toast.success = (msg, delay = 5000) => createToast(msg, delay, 'success');
  Toast.warn = (msg, delay = 6000) => createToast(msg, delay, 'warning');
  Toast.error = (msg, delay = 6000) => createToast(msg, delay, 'error');

  Toast.remove = id => toastVm?.removeToastById(id);

  export default Toast;
</script>

<style lang="scss">
  @import '~scss/mixins';
  @import '~scss/variables';

  $default-grid-pixels: 8px;

  .comp-toast {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    top: $default-grid-pixels * 1;
    right: $default-grid-pixels * 1;
    z-index: 200;

    .toast {
      position: relative;
      display: inline-block;
      padding: $default-grid-pixels * 2 $default-grid-pixels * 4 $default-grid-pixels * 2 $default-grid-pixels * 5;
      background-color: $color-white-solid-10;
      margin-bottom: $default-grid-pixels * 3;
      box-shadow: 2px 1px 0 rgba(0,0,0,0.1);
      border-radius: $default-border-radius;
      align-self: flex-end;
      max-width: 40vw;
      z-index: 2;
      text-align: left;
      animation: toast $default-transition;

      &:after {
        content: '';
        position: absolute;
        left: 0;
        z-index: 1;
        top: 0;
        width: 100%;
        height: 100%;
        border-radius: $default-border-radius;
        border: 1px solid currentColor;
        opacity: 0.3;
      }
      .icon {
        position: absolute;
        margin-left: -#{$default-grid-pixels * 3.5};
        top: calc(50% - 1px);
        transform: translate(0, -50%);
        font-size: 130%;
      }

      .close {
        position: absolute;
        top: $default-grid-pixels * 1.25;
        right: $default-grid-pixels * 2.25;
        cursor: pointer;
        user-select: none;
        z-index: 3;

        & > span {
          position: absolute;
          display: block;
          background-color: currentColor;
          opacity: 0.5;
          width: 12px;
          font-size: 0;
          height: 2px;
          transform-origin: 50% 50%;

          &:nth-child(1) { transform: rotate(45deg ); }
          &:nth-child(2) { transform: rotate(-45deg ); }
        }
      }

      &.info {
        color: #00529B;
        background-color: #BDE5F8;
      }
      &.success {
        color: #4F8A10;
        background-color: #DFF2BF;
      }
      &.warning {
        color: #9F6000;
        background-color: #FEEFB3;
      }
      &.error {
        color: #D8000C;
        background-color: #FFD2D2;
      }
    }
  }
</style>
